import type { KycCertificationRequirementFlags } from '@dealstack/shared/lib/common/business/kycCertification';
import {
	KycCertificationChoiceMode,
	type DataKYCFileTct,
	type KycFileCertificationChoiceDto,
	KYCFileType,
} from '@dealstack/shared/lib/generated';
import type { CertificationChoiceFormValues } from './CertifiableProof.types';

const FLAG_BY_FILE_TYPE: Partial<Record<KYCFileType, keyof KycCertificationRequirementFlags>> = {
	[KYCFileType.PROOF_OF_IDENTITY]: 'isProofOfIdentityCertificationRequired',
	[KYCFileType.PROOF_OF_ADDRESS]: 'isProofOfAddressCertificationRequired',
	[KYCFileType.INVESTMENT_VEHICLE]: 'isProofOfInvestmentVehicleCertificationRequired',
};

/** Whether the workflow's settings want this proof type certified. */
export const isCertificationRequiredFor = (
	flags: Partial<KycCertificationRequirementFlags> | null | undefined,
	type: KYCFileType
): boolean => {
	const flag = FLAG_BY_FILE_TYPE[type];
	return !!flags && !!flag && !!flags[flag];
};

export const toCertificationChoice = (
	values: CertificationChoiceFormValues
): KycFileCertificationChoiceDto =>
	values.mode === KycCertificationChoiceMode.SELF_ATTESTED
		? { mode: values.mode, attested: values.attested }
		: {
				mode: values.mode,
				certifierName: values.certifierName.trim(),
				certifierEmail: values.certifierEmail.trim(),
			};

/** Pre-fills the choice form from what the file already has; a pending nomination opens in certifier mode. */
export const certificationChoiceDefaults = (
	kycFile?: Pick<DataKYCFileTct, 'certification'>
): CertificationChoiceFormValues => ({
	mode: kycFile?.certification
		? KycCertificationChoiceMode.CERTIFIER
		: KycCertificationChoiceMode.SELF_ATTESTED,
	attested: false,
	certifierName: kycFile?.certification?.certifierName ?? '',
	certifierEmail: kycFile?.certification?.certifierEmail ?? '',
});
